import * as React from 'react';
import './index.scss';
import openLink from 'libs/open-link';
import { sendEvent } from 'libs/event';

export interface IActivity {
    id: number;
    name: string;
    // eslint-disable-next-line camelcase
    feed_title: string;
    // eslint-disable-next-line camelcase
    feed_subtitle: string;
    // eslint-disable-next-line camelcase
    card_type: string;
    type: number;
    content: string;
    // eslint-disable-next-line camelcase
    feed_image_url: string;
}

export interface IActivityProps {
    activity: IActivity;
    beforeReportEvent?: (params: {
        [key: string]: string | number;
    }) => { [key: string]: string | number };
    beforeClickActivity?: (url: string, act: IActivity) => string;
}

export function Activity(props: IActivityProps) {
    function retrieveActivityUrl(activity: IActivity) {
        if (activity.type === 1) {
            return '/views/channel/activity';
        }

        return activity.content;
    }

    function clickActivityEvent(id: number) {
        const extra = { activity_id: id };
        // props.beforeReportEvent(extra);
        sendEvent('click_activity_card', extra);
    }

    function clickActivity() {
        let url = retrieveActivityUrl(props.activity);
        if (url) {
            if (props.activity.type === 1) {
                url += '?id=' + props.activity.id;
            }
            // url = props.beforeClickActivity(url, props.activity);
        } else {
            url = '/errorpage/index?type=1';
        }
        clickActivityEvent(props.activity.id);
        openLink(url, { title: props.activity.name });
    }

    return (
        <div className="activity" onClick={clickActivity}>
            <div className="activity__img">
                <img
                    className="activity__img--detail"
                    alt="活动图片"
                    src={props.activity.feed_image_url}
                />
            </div>
            <div className="activity__detail">
                <div className="activity__detail-title">
                    <span className="activity__detail-title--text">
                        {props.activity.feed_title}
                    </span>
                </div>
                <div className="activity__detail-subtitle">{props.activity.feed_subtitle}</div>
                <div className="activity__detail-btn">查看全部</div>
            </div>
        </div>
    );
}
